import styled from "styled-components";
import {
    TextField,
} from "@material-ui/core";
import ActionFileUpload from './ActionFileUploadV2';
import ActionDeviationFiles from './ActionDeviationFilesV2';


const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 15px;
font-weight: 500;
`

const TextFieldContainer = styled.div`
  width: 100%;
`;

const ActionFileUploadContainer = styled.div`
  padding-top:20px;
  display:grid;
  grid-template-columns:1fr 1fr;
  width:100%;
`

export const DeviationForPartiallyaddendum = (props) => {
    const { modifiedProcedureUrl,
        onChangeModifiedProcedureUrl,
        onUrlBlur,
        helperText,
        error,
        attachments,
        onDeleteAttachment,
        deviationReasoning,
        onChangeDeviationReasoning
    } = props
    return (
        <>
            {/* <TextField label="Url" value={this.state.modifiedProcedureUrl} onChange={event => this.setState({ modifiedProcedureUrl: event.target.value })} fullWidth margin="normal" variant="outlined" /> */}
            <TextField label="Url"
                value={modifiedProcedureUrl}
                onChange={onChangeModifiedProcedureUrl}
                onBlur={onUrlBlur}
                fullWidth
                margin="normal"
                variant="outlined"
                helperText={helperText}
                error={error}
            />
            <ActionFileUploadContainer>
                <ActionFileUpload />
                <ActionDeviationFiles attachments={attachments} onDeleteAttachment={onDeleteAttachment} />
            </ActionFileUploadContainer>
            <TextFieldLabel>
                Reason for deviation*
            </TextFieldLabel>
            <TextFieldContainer>
                <TextField placeholder="Start typing..." value={deviationReasoning} onChange={onChangeDeviationReasoning} multiline fullWidth margin="normal" variant="outlined" />
            </TextFieldContainer>
        </>);
}